export default {
  SET_INVOICES(state, wallets) {
    state.wallets = wallets
  },
  SET_INVOICES_COUNT(state, count) {
    state.walletsCount = count
  },
  REMOVE_RECORD(state, itemId) {
    const index = state.wallets.findIndex(u => u.id === itemId)
    state.wallets.splice(index, 1)
  }
}
